import { useMutation, useQueryClient } from '@tanstack/react-query';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';


import { createGpt } from 'api/gpts';
import Container from 'components/Container';
import SelectInput from 'components/Form/SelectInput';
import TextInput from 'components/Form/TextInput';
import MobileHeader from 'components/MobileHeader';
import SearchOverlay from 'components/SearchOverlay';
import Sidebar from 'components/Sidebar';

export default function Create() {

    const [sidebar, setSidebar] = useState(false);
    const [search, setSearch] = useState(false);

    const cache = useQueryClient();
    const navigate = useNavigate();

    const { mutate: create } = useMutation({
        mutationKey: ['createGpt'],
        mutationFn: createGpt,
        onSuccess: (data) => {
            console.log("GPT created successfully:", data);
            cache.invalidateQueries(['gpts']);

            return navigate(`/settings/gpts/`);
        },
        onError: (error) => {
            console.error("Error creating GPT:", error);
        }
    });


    function onSubmitHandler(formEvent) {
        const data = Object.fromEntries(formEvent);
        console.log("Form data submitted:", data);
        const formData = {
            name: data.name,
            slug: data.slug,
            apiKey: data.apiKey,
            url: data.url,
        }
        if (data.enabled) {
            formData.enabled = 'true';
        } else {
            formData.enabled = 'false';
        }
        if (data.public) {
            formData.public = 'true';
        } else {
            formData.public = 'false';
        }

        console.log("Submitting GPT creation with data:", formData);

        create({
            data: formData
        });
    }


    return (
        <>
            <Sidebar
                visible={sidebar}
                setVisible={setSidebar}
            />

            <SearchOverlay
                visible={search}
                setVisible={setSearch}
            />

            <MobileHeader
                sidebar={sidebar}
                setSidebar={setSidebar}
                search={search}
                setSearch={setSearch}
            />
            <div className={`fixed top-0 w-full bottom-0 transition-all duration-300 ease-in-out lg:pl-[320px] ${sidebar ? 'left-[80vw]' : 'left-0'}`}>
                <Container className='!min-w-[700px] !max-w-[700px]'>
                    <div className='pb-8 pt-20 md:pt-14 text-center'>
                        <p className='text-3xl'>Crea nuovo GPT</p>
                    </div>
                    <div className=''>
                        <form action={onSubmitHandler} className='flex flex-col gap-4'>
                            <TextInput
                                label="Nome"
                                name="name"
                                placeholder="Nome"
                            />

                            <TextInput
                                label="Slug"
                                name="slug"
                                placeholder="Slug"
                                className="mt-4"
                            />

                            <TextInput
                                label="API Key"
                                type="text"
                                name="apiKey"
                                className="mt-4"
                            />

                            <TextInput
                                label="URL"
                                type="text"
                                name="url"
                                className="mt-4"
                            />

                            <SelectInput
                                label="Abilitato"
                                name="enabled"
                                options={[
                                    { value: 'true', label: 'Sì' },
                                    { value: 'false', label: 'No' }
                                ]}
                                className="mt-4"
                            />
                            <SelectInput
                                label="Pubblico"
                                name="public"
                                options={[
                                    { value: 'true', label: 'Sì' },
                                    { value: 'false', label: 'No' }
                                ]}
                                className="mt-4"
                            />
                            <SelectInput
                                label="Tipo"
                                name="type"
                                options={[
                                    { value: 'model', label: 'Modello' },
                                    { value: 'embedding', label: 'Embedding' }
                                ]}
                                className="mt-4"
                            />

                            <div className='flex justify-end'>
                                <button type="submit" className='mt-6 bg-black hover:bg-greydark text-white text-sm font-medium px-6 py-3 rounded-md transition-colors cursor-pointer duration-200'>Crea</button>
                            </div>
                        </form>
                    </div>
                </Container>
            </div>
        </>
    )
}
